import { gql } from '@apollo/client'
import { workOrderDocumentFragment } from './graphql'
import { useActionMutation, type UseActionResult, type UseMutationProps } from '@ztechapps/common.hook'
import type { AddConsumptionUsingBomArgs, WorkOrder } from '@ztechapps/common.contract'

export const addConsumptionUsingBomQuery = gql`
  mutation addConsumptionUsingBom($input: AddConsumptionUsingBomArgs!) {
    addConsumptionUsingBom(input: $input) {
      ...workOrderDocumentFragment
    }
  }
  ${workOrderDocumentFragment}
`

export const useAddConsumptionUsingBom = (
  { query, ...props } = {} as UseMutationProps
): UseActionResult<WorkOrder, AddConsumptionUsingBomArgs> => {
  query = query ?? addConsumptionUsingBomQuery

  return useActionMutation({
    query,
    ...props,
  })
}
